import styled from "styled-components";
import { media } from "Utils/breakpoints";

interface ZoneSelectorButtonProps {
  active: boolean;
}

export const ZoneSelectorWrapperStyled = styled.div`
  /* Intentionally not 'position: relative' — the dropdown should position
     against ZoneNameRowStyled so its left edge aligns with the zone name,
     not with the chevron icon next to it. */
`;

export const ZoneSelectorButtonStyled = styled.button<ZoneSelectorButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  /* Removed margin-left: 8px — gap is already provided by ZoneNameRowStyled */

  svg {
    width: 24px;
    height: 24px;
    transform: ${(props) => (props.active ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.3s;
  }

  &:hover {
    opacity: 0.7;
  }

  ${media.portrait} {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const ZoneSelectorDropdownStyled = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  background-color: #ffffff;
  box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
  border-radius: 4px;
  z-index: 10000;
  min-width: 300px;
  max-height: 400px;
  overflow-y: auto;
  padding: 8px 0;

  /* Portrait kiosk: detach from the trigger and center horizontally on screen. */
  ${media.portrait} {
    position: fixed;
    top: 88px;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 0;
  }
`;

export const ZoneSelectorItemStyled = styled.div`
  font-size: 16px;
  color: #606060;
  padding: 14px 18px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    color: #55b8b3;
    background-color: #f4f4f4;
  }
`;
